import { restApiClient } from '@/datasources';
import { City } from '@/types/city.type';

export type SearchCitiesResponse = {
  results: City[];
};

export async function searchCitiesByTerm(searchTerm: string): Promise<SearchCitiesResponse> {
  const { data } = await restApiClient.get<SearchCitiesResponse>('/search/search-cities/', {
    name: searchTerm,
  });

  return data;
}
